<template>
  <div>
    <div class="container-fluid pt-5">

      <Loading v-if="loading" style="height: 800px" />

      <div class="row pb-4" v-else>
        <div class="col-sm-12 col-lg-6 col-xl-6 xl-50 col-md-12">
          <div class="card mb-0 h-100">
            <div class="card-header">
              <h5>Details</h5>
              <button class="btn btn-pill btn-light" @click="$router.go(-1)">Go back</button>
            </div>
            <div class="card-body">
              <div class="media markets">
                <img width="90" height="90" v-if="goal_data.coverImageUrl" :src="goal_data.coverImageUrl" alt="" @error="imageLoadError(goal_data.id)">
                <img width="90" height="90" v-else src="../../assets/images/default-img.jpg" alt="" />
                <div class="media-body">
                  <h5>{{ goal_data.title }}</h5>
                  <small class="font-primary" v-html="moment(goal_data.createdAt)"></small>
                  <p>{{ goal_data.fullDescription }}</p>
                  <div class="trac-categories mb-3" v-if="goal_data.tracCategories">
                    <p class="mb-0 ml-1"><strong>Categories</strong></p>
                    <span v-for="(item, index) in goal_data.tracCategories" :key="index">
                      {{ item.name }}
                    </span>
                  </div>
                  <div class="ml-1">
                    <p><strong>Price: </strong><span>${{ goal_data.price }}</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-lg-6 col-xl-6 xl-50 col-md-12">
          <div class="card mb-0 h-100" v-if="getOneGoal()">
            <div class="card-header"><h5>Goal</h5></div>
            <div class="card-body">
              <div class="media faq-widgets">
                <div class="media-body">
                  <h5>{{getOneGoal().title}}</h5>
                  <p>{{getOneGoal().description}}</p>
                  <button id="default-light" type="button" class="btn btn-pill btn-light" @click="addGoalModal">
                    <i class="fa fa-edit"></i> Edit Goal
                  </button>
                </div>

                <i data-v-07452373="" data-name="book-open" data-tags="read,library" data-type="book-open"
                   class="feather feather--book-open">
                  <svg data-v-07452373="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                       fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                       class="feather feather-book-open feather__content">
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                  </svg>
                </i>
              </div>
            </div>

            <b-modal ref="edit-goal" title="Edit Goal" hide-footer>
              <form @submit.prevent="handleEdit">
                <div class="form-group">
                  <label for="goal-edit-title">Title</label>
                  <input type="text" v-model="goalEdit.title" id="goal-edit-title" name="title" class="form-control" :class="{ 'is-invalid': submittedEdit && $v.goalEdit.title.$error }" />
                  <div v-if="submittedEdit && !$v.goalEdit.title.required" class="invalid-feedback">Title is required</div>
                </div>
                <div class="form-group">
                  <label for="goal-edit-description">Description</label>
                  <textarea rows="3" v-model="goalEdit.description" id="goal-edit-description" name="description" class="form-control" :class="{ 'is-invalid': submittedEdit && $v.goalEdit.description.$error }" ></textarea>
                  <div v-if="submittedEdit && !$v.goalEdit.description.required" class="invalid-feedback">Description is required</div>
                </div>
                <div class="form-group">
                  <button class="btn btn-primary" :disabled="loadingBtn">Update</button>
                </div>
              </form>
            </b-modal>
          </div>

          <div class="card mb-0 h-100" v-else>
            <div class="card-body">
              <div class="media faq-widgets add-first-goal">
                <div class="w-100 d-flex justify-center">
                  <div class="add-goal" @click="$refs['add-goal'].show()">
                    <i class="fa fa-plus"></i>
                    Add goal
                  </div>
                </div>
              </div>
            </div>

            <b-modal ref="add-goal" title="Add Goal" hide-footer>
              <form @submit.prevent="handleAdd">
                <div class="form-group">
                  <label for="goal-title">Title</label>
                  <input type="text" v-model="goal.title" id="goal-title" name="title" class="form-control" :class="{ 'is-invalid': submitted && $v.goal.title.$error }" />
                  <div v-if="submitted && !$v.goal.title.required" class="invalid-feedback">Title is required</div>
                </div>
                <div class="form-group">
                  <label for="goal-description">Description</label>
                  <textarea rows="3" v-model="goal.description" id="goal-description" name="description" class="form-control" :class="{ 'is-invalid': submitted && $v.goal.description.$error }" ></textarea>
                  <div v-if="submitted && !$v.goal.description.required" class="invalid-feedback">Description is required</div>
                </div>
                <div class="form-group">
                  <button class="btn btn-primary" :disabled="loadingBtn">Add Goal</button>
                </div>
              </form>
            </b-modal>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div v-if="getOneGoal()">
            <Milestones :id="getOneGoal().id" :tracId="this.$route.params.id" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from "../../components/loading";
  import moment from "moment";
  import { required } from "vuelidate/lib/validators";
  import Milestones from "../../components/milestones";

  export default {
    name: "trac-view",
    components: {
      Milestones,
      Loading
    },
    data() {
      return {
        loadingBtn: false,
        goal_data: [],
        loading: true,
        goal: {
          title: "",
          description: ""
        },
        goalEdit: {
          title: "",
          description: ""
        },
        submittedEdit: false,
        submitted: false
      }
    },
    validations: {
      goal: {
        title: { required },
        description: { required }
      },
      goalEdit: {
        title: { required },
        description: { required }
      },
    },
    methods: {
      init() {
        this.loading = true;

        if (this.$route.params.id) {
          this.$store.dispatch("getTracById", this.$route.params.id)
          .then(async(val) => {
            if (val.data.statusCode === 200) {
              this.goal_data = val.data.result;
              this.loading = false;
            }
            else {
              this.toaster('error', val.data.result);

              this.goal_data = null;
              this.loading = true;
            }
          })
          .catch(async(val) => {
            const message = this.formatExceptionMessage(val);
            this.toaster('error', message);

            this.loading = false;
          });
        }
      },
      moment(date) {
        return `${moment(date).format('D')} ${moment(date).format('MMM')}`
      },
      imageLoadError(id) {
        if (this.goal_data.details.uid === id) {
          this.goal_data.details.coverImageUrl = require('../../assets/images/default-img.jpg')
        }
      },
      getOneGoal() {
        if (this.goal_data.goals) {
          return this.goal_data.goals[Object.keys(this.goal_data.goals)[0]]
        } else {
          return null
        }
      },
      handleAdd() {
        this.submitted = true;
        this.loadingBtn = true;

        this.$v.goal.$touch();
        if (this.$v.goal.$invalid) {
          this.loadingBtn = false;
          return;
        }

        this.goal.tracId = this.goal_data.id;

        this.$store.dispatch('addGoal', this.goal).then(() => {
          this.$toasted.show(' Successfully added ', {
            theme: 'bubble',
            position: "top-right",
            type: 'success',
            duration: 2000
          });
          this.$refs['add-goal'].hide();
          this.loadingBtn = false;
          this.init();
        }).catch(() => {
          this.$toasted.show(' Please try again ', {
            theme: 'bubble',
            position: "top-right",
            type: 'error',
            duration: 2000
          });
          this.$refs['add-goal'].hide();
          this.loadingBtn = false;
        })
      },
      addGoalModal() {
        this.goalEdit.tracId = this.goal_data.id;
        this.goalEdit.id = this.getOneGoal().id;
        this.goalEdit.title = this.getOneGoal().title;
        this.goalEdit.description = this.getOneGoal().description;
        this.$refs['edit-goal'].show();
      },
      async handleEdit() {
        this.submittedEdit = true;
        this.loadingBtn = true;

        this.$v.goalEdit.$touch();
        if (this.$v.goalEdit.$invalid) {
          return;
        }

        let res = await this.$store.dispatch('editGoal', this.goalEdit);
        this.loadingBtn = false;
        if (res.status === 200) {
          this.$toasted.show(' Successfully Changed ', {
            theme: 'bubble',
            position: "top-right",
            type: 'success',
            duration: 2000
          });
          this.$refs['edit-goal'].hide();
          this.init();
        } else {
          this.$toasted.show(' Please try again ', {
            theme: 'bubble',
            position: "top-right",
            type: 'error',
            duration: 2000
          });
        }
      },
      formatExceptionMessage(val) {
        const resp = val.response.data;
        return resp.responseException && resp.responseException.exceptionMessage ? resp.responseException.exceptionMessage : 'Please try again';
      },
      toaster(type, message) {
        this.$toasted.show(message, {
          theme: 'bubble',
          position: 'top-right',
          type: type,
          duration: 3000
        });
      }
    },
    watch: {
      '$route.params': {
        immediate: true,
        handler() {
          this.init()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .cal-img {
    overflow: hidden;
    height: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .cal-date {
    position: relative;
    z-index: 1;
  }
  .number-wrapper {
    width: 58px;
    height: 58px;
    background-color: #eef1ff;
    font-size: 20px;
    font-weight: 600;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
  }
  .new-users {
    .media {
      cursor: pointer;
    }
  }
  .list-milestones {
    cursor: pointer;
    border-top: 1px solid #edf1ff;

    h6 {
      font-weight: 600;
      color: #02a9f7;
    }
  }

  .add-first-goal {

    &>.w-100 {
      justify-content: center;
    }

    .add-goal {
      font-size: 20px;
      cursor: pointer;
      user-select: none;
    }
  }

  .card {
    .media.markets {
      margin-bottom: 0;
      align-items: flex-start;

      img {
        object-fit: cover;
      }

      .media-body {
        h5 {
          font-weight: 600;
          font-size: 1.25rem;
        }
      }
    }
  }

  .trac-categories {
    span {
      background: #ffffff;
      color: #4466f2;
      padding: 2px 10px;
      line-height: 1;
      border-radius: 4px;
      border: 1px solid;
      margin: 3px 4px;
      display: inline-block;
      user-select: none;
    }
  }
  .card-header {
    display: flex;
    justify-content: space-between;
  }
</style>
